import { MaterialQualitySystem } from "./MaterialQualitySystem";
import { FacetRenderer } from "../renderable/Renderable";
export class HideWhenQualityRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.wasHidden = false;
    }
    onInit({}) {
        const system = this.owner.renderer.getSystem(MaterialQualitySystem);
        system.add(this);
    }
    destroy() {
        if (this.wasHidden) {
            this.owner.visible = true;
        }
    }
    setVisible(visible) {
        const system = this.owner.renderer.getSystem(MaterialQualitySystem);
        if (visible) {
            system.add(this);
            this.execute();
        }
        else {
            if (this.wasHidden) {
                this.owner.visible = true;
            }
            system.delete(this);
        }
    }
    updateFacet() {
        this.execute();
    }
    updateTransform() { }
    execute() {
        if (this.facet && this.owner.renderer.getSystem(MaterialQualitySystem).materialQuality <= this.facet.quality) {
            this.owner.visible = false;
            this.wasHidden = true;
        }
    }
}
